import { EVENT_STATUS } from 'utils/constants/status';

export const handleSubscriptionDataUpdate = (
  events,
  totalEvents = [],
  attributeKey = 'id',
  shouldShowCanceled = true,
  shouldShowDeleted = true
) => {
  console.log('Calendar subscription: events ', events);
  console.log('Calendar subscription: total events ', totalEvents);
  console.log('Calendar subscription: attribute key ', attributeKey);
  console.log('Calendar subscription: showing Canceled ', shouldShowCanceled);
  console.log('Calendar subscription: showing Delete ', shouldShowDeleted);
  if (!events || events?.length === 0) return totalEvents;
  console.log('Calendar subscription: continued after length check ', events);

  events?.forEach(event => {
    event.dayOfWeek = new Date(event?.startDate).getDay();
    
    // Log the attribute values for debugging
    console.log('Calendar subscription: event attribute value:', {
      eventAttributeValue: event[attributeKey],
      eventId: event.id,
      eventStatus: event.status,
      attributeKey
    });
    
    const index = totalEvents?.findIndex(
      x => x[attributeKey] === event[attributeKey]
    );
    
    console.log('Calendar subscription: found index:', index, 'for event:', event[attributeKey]);

    if (event.status === EVENT_STATUS.deleted) {
      console.log('Calendar subscription: Entered delete');
      totalEvents = totalEvents.filter(
        x => x[attributeKey] !== event[attributeKey]
      );
    } else if (event.status === EVENT_STATUS.canceled) {
      console.log(
        'Calendar subscription: Entered cancel , event to remove',
        event
      );
      console.log('Calendar subscription: Looking for calendarID:', event[attributeKey]);
      console.log('Calendar subscription: Existing calendarIDs:', totalEvents.map(e => e[attributeKey]).slice(0, 10));
      
      const beforeCount = totalEvents.length;
      totalEvents = totalEvents.filter(
        x => x[attributeKey] !== event[attributeKey]
      );
      const afterCount = totalEvents.length;
      console.log('Calendar subscription: Removed', beforeCount - afterCount, 'events');

      if (shouldShowCanceled && index < 0) {
        console.log(
          'Calendar subscription: cancel filter is enabled and event is new'
        );
        totalEvents = [event, ...totalEvents];
      }
    } else {
      console.log('Calendar subscription: Adding Event ', event);
      totalEvents = totalEvents.filter(
        x => x[attributeKey] !== event[attributeKey]
      );
      totalEvents = [event, ...totalEvents];
    }
  });

  totalEvents.forEach(eachEvent => {
    console.log(eachEvent, 'Each Event of totalEvents');
  });

  return totalEvents;
};
